import { connect } from "react-redux";

import DatePicker from "react-datepicker";
import moment from "moment";

var CurrentUser = require("lib/account/CurrentUser");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("appdev/crm/agent_task_form.scss");

@connect(
	(state, props) => {
		return {
			agentEmails: CurrentUser.get().crm_config.active_user_emails,
		}
	},
	(dispatch, props) => ({})
)
class AgentTaskForm extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onUpdate(key, e) {
		this.props.onChange(key, e.target.value);
	}
	toggleActive() {
		this.props.onChange("active", !this.props.task.active);
	}
	onDateChange(momentDate) {
		this.props.onChange("date", momentDate.format("YYYY-MM-DD"));
	}

	renderAgentOptions() {
		return this.props.agentEmails.slice().sort().map((email) => {
			return (
				<option key={ email } value={ email }>
					{ email }
				</option>
			);
		})
	}

	render() {
		return (
			<div className="agentTaskForm">
				<div className="row">
					<div className="col-sm-2">
						<label>
							Next Task?
						</label>
						<div>
							<Glyphicon className="clickableElement taskActive" onClick={ this.toggleActive }
								icon={ this.props.task.active ? "check" : "unchecked" } />
						</div>
					</div>
					<div className="col-sm-2">
						<label>
							Date
						</label>
						<DatePicker className="form-control"
							selected={ moment(this.props.task.date) }
							onChange={ this.onDateChange } />
					</div>
					<div className="col-sm-4">
						<label>
							Task
						</label>
						<input value={ this.props.task.text || "" } className="form-control"
							onChange={ this.onUpdate.bind(this, "text") } />
					</div>

					<div className="col-sm-4">
						<label>
							Agent
						</label>
						<select value={ this.props.task.agentEmail || "" } className="form-control"
							onChange={ this.onUpdate.bind(this, "agentEmail") }>
							<option value=""></option>
							{ this.renderAgentOptions() }
						</select>
					</div>
				</div>
			</div>
		);
	}

};

AgentTaskForm.WrappedComponent.propTypes = PageStrictPropTypes({
	// From component above
	task: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,

	// Data from @connect
	agentEmails: PropTypes.array.isRequired,
});

module.exports = AgentTaskForm;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/AgentTaskForm.js